export default __webpack_public_path__ + "static/media/transparent-figure.eee8bea3.webp";